export const CONFLICT_RESOLUTIONS = {
  overwrite: 'overwrite',
  update_if_blank: 'update_if_blank',
  add_only: 'add_only',
  remove_only: 'remove_only',
  overwrite_except_null: 'overwrite_except_null',
} as const;

export const FILTER_TYPES = {
  in_group: 'in_group',
  not_in_group: 'not_in_group',
  custom_filter: 'custom_filter',
  all_records: 'all_records',
} as const;
